import {
  CallFilled,
  CallMissedFilled,
  CallMissedRegular,
  CallRegular,
  HeadsetFilled,
  HeadsetRegular,
} from '@fluentui/react-icons';
import { Link, useLocation } from '@tanstack/react-router';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

const menuItems = [
  {
    path: '/phone',
    label: 'Telefone',
    icons: {
      Filled: CallFilled,
      Regular: CallRegular,
    },
  },
  {
    path: '/history',
    label: 'Histórico',
    icons: {
      Filled: CallMissedFilled,
      Regular: CallMissedRegular,
    },
  },
  {
    path: '/audio-settings',
    label: 'Áudio',
    icons: {
      Filled: HeadsetFilled,
      Regular: HeadsetRegular,
    },
  },
];

const Navbar = () => {
  const { t } = useTranslation('navbar');

  const pathname = useLocation({
    select: (location) => location.pathname,
  });

  return (
    <div className="navbar-shadow flex items-center justify-between space-x-1 border-t border-[#c8c8c8] bg-[#fafafa] px-4 py-2 transition-all">
      {menuItems.map(({ path, label, icons }) => {
        const isActive = pathname === path;

        return (
          <Link
            to={path}
            key={path}
            disabled={isActive}
            className="grow transition-all"
          >
            <Button
              variant="ghost"
              size={isActive ? undefined : 'icon'}
              className={classNames(
                'w-full transition-all hover:bg-[#ececec] active:bg-[#dddddd]',
                {
                  'cursor-default bg-[#ececec]': isActive,
                }
              )}
            >
              {isActive ? (
                <icons.Filled color="#5a5a5a" fontSize={22} className="mr-2" />
              ) : (
                <icons.Regular color="#5a5a5a" fontSize={22} />
              )}
              {isActive && (
                <span className="select-none text-[#5a5a5a]">{t(label)}</span>
              )}
            </Button>
          </Link>
        );
      })}
    </div>
  );
};

export default Navbar;
